(() => {
  const init = (root) => {
    if (root.dataset.qlTrackReady === 'true') return;
    root.dataset.qlTrackReady = 'true';
    const form = root.querySelector('[data-ql-track-form]');
    const status = root.querySelector('[data-ql-track-status]');
    if (!form) return;

    const orderFromUrl = new URLSearchParams(window.location.search).get('order');
    if (orderFromUrl) form.elements.order.value = orderFromUrl;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const order = form.elements.order.value.trim();
      const phone = form.elements.phone.value.replace(/\D/g, '');
      const whatsapp = root.dataset.whatsappNumber.replace(/\D/g, '');

      if (!order) {
        status.textContent = 'Veuillez saisir votre numéro de commande.';
        form.elements.order.focus();
        return;
      }
      if (!/^\d{8}$/.test(phone)) {
        status.textContent = 'رقم الهاتف يجب أن يحتوي على 8 أرقام.';
        form.elements.phone.focus();
        return;
      }
      if (!whatsapp) {
        status.textContent = 'Ajoutez le numéro WhatsApp dans les réglages de cette section.';
        return;
      }

      status.textContent = 'Ouverture de WhatsApp…';
      const text = `${root.dataset.message}\nCommande: ${order}\nTéléphone: +216 ${phone}`;
      window.open(`https://wa.me/${whatsapp}?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-ql-track]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
